export const DEFAULT_GAME_PLAYER = {
    'id': 0,
    'created': '2023-03-22T11:06:52.896709-07:00',
    'modified': '2023-03-22T11:06:53.197488-07:00',
    'station': [
        49,
        4,
        6,
        7,
        10,
        12,
        57,
        null,
        56,
        56
    ],
    'docks': [
        null,
        null,
        38,
        38
    ],
    'lodging': [
        44,
        43,
        null,
        null,
        null,
        null
    ],
    'action_tokens': [],
    'storage': [],
    'robot_storage': [
        1,
        2
    ],
    'robot_market': [
        3,
        4,
        5,
        6,
        7,
        8
    ],
    'robot_assignments': [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
    ],
    'options': null,
    'name': 'Default',
    'seat': 0,
    'current_score': 0,
    'current_round_points': 0,
    'locked_rooms': [],
    'turn_starttime': null,
    'available_actions': [
        [
            null,
            null,
            null,
            null
        ],
        [
            null,
            null,
            null,
            null
        ]
    ],
    'locked_action_stacks': [
        false,
        false
    ],
    'action_hex_position': 0,
    'action_hex_locked': false,
    'action_grid': [],
    'special_card_orbit': null,
    'attacking_ghosts': 0,
    'attacking_cards': [],
    'current_fate': null,
    'randoms_used_this_round': [],
    'created_by': 1,
    'modified_by': 1,
    'game': null,
    'player': null,
    'artificial_player': null,
    'status': 1,
    'faction': 1,
    'captain': 1,
    'ship': 1,
    'bridge': 1,
    'turn_status': null,
    'current_action': null,
    'action_status': null,
    'special_card': null,
    'current_attacking_card': null,
    'last_event': null
};


export const DEFAULT_GAME = {
    'id': 0,
    'created': '2023-03-22T11:06:52.896709-07:00',
    'modified': '2023-03-22T11:06:53.197488-07:00',
    'status': 1,
    'draft_choices': [1, 2],
    'gameplayer_set': [0, 1, 2, 3, 4, 5].map((seat) => {
        let gamePlayer = { ...DEFAULT_GAME_PLAYER };
        gamePlayer.seat = seat;
        return gamePlayer;
    }),
}
